import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<path d=\"M8 14V8H14V6H8V0H6V6H0V8H6V14H8Z\" fill={{this.pathColor}}></path>", {
  moduleName: "@dashboard/shared-ui/components/svgs/market/plus.hbs"
});